import { GISService, GISServiceTypes } from './gisServicesTypes';

/**
 * How the map layers are ordered:
 *
 * **LOWEST LAYER**
 *  Esri-provided map (if turned on in Basemap Menu)
 *  WMS and WMTS imagery layers (sorted by display_order)
 *  GIS Basemap
 *  Supplemental layers (sorted by display_order)
 *  Deck.gl
 * **TOPMOST LAYER**
 */

const SERVICE_TYPE_ORDERING: Record<number, number> = {
  // geocode layers don't appear at all
  [GISServiceTypes.geocode]: -1,

  // mws and wmts are maps layers that cover the whole area; like aerial
  // photography. These layers sit below the basemap, so road names, etc, are
  // still visible
  [GISServiceTypes.wms]: 0,
  [GISServiceTypes.wmts]: 0,

  // the basemap sits below all supplemental layers
  [GISServiceTypes.basemap]: 1,

  // Everyone else sits on top
  [GISServiceTypes.supplemental]: 2,
};

export const gisServiceSort = (a: GISService, b: GISService) => {
  if (
    SERVICE_TYPE_ORDERING[a.service_type] !==
    SERVICE_TYPE_ORDERING[b.service_type]
  ) {
    return (
      SERVICE_TYPE_ORDERING[a.service_type] -
      SERVICE_TYPE_ORDERING[b.service_type]
    );
  } else if (
    // Display order controls the ordering within a service type:
    a.display_order &&
    b.display_order &&
    b.display_order !== a.display_order
  ) {
    // Note that this is the reverse of what you might expect!
    return b.display_order - a.display_order;
  }
  // If all else fails, sort 'em alphabetically, to ensure a deterministic
  // order.
  return a.display_name < b.display_name ? -1 : 1;
};
